import React from "react";
import logo from "../images/logo.png";
import defaultuser from "../images/defaultuser.png";
import { Link, NavLink } from "react-router-dom";
import $ from "jquery";

class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.state.user,
    };
  }

  componentDidMount() {
    $(".navbar-burger").click(function () {
      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      $(".navbar-burger").toggleClass("is-active");
      $(".navbar-menu").toggleClass("is-active");
    });
  }

  render() {
    return (
      <nav className="navbar has-shadow is-info is-fixed-top">
        <div className="navbar-brand">
          <a className="navbar-item has-text-white" href="/">
            <img src={logo} alt="" />
          </a>
          <div
            className="navbar-burger burger"
            data-target="navbarExampleTransparentExample"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div id="navbarExampleTransparentExample" className="navbar-menu">
          <div className="navbar-start has-text-white">
            <NavLink to="/myshop/home/" className="navbar-item is-active">
              <span className="zmdi zmdi-home mr-2"></span>
              <span className="">Shop</span>
            </NavLink>
            <div className="navbar-item has-dropdown is-hoverable">
              <div className="navbar-link">
                <span className="zmdi zmdi-shopping-basket mr-2"></span>
                Stock
              </div>

              <div className="navbar-dropdown">
                <div className="navbar-item">
                  <Link to="/myshop/all-stocks/">
                    <span>All Stocks</span>
                  </Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/stocks-added/">
                    <span>Stocks Added</span>
                  </Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/stock-changes/">
                    <span>Stock Changes</span>
                  </Link>
                </div>
                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/stocks-running-out/">
                    <span>Stocks Running-Out</span>
                  </Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/command/">
                    <span>Command</span>
                  </Link>
                </div>
                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/inventory/">
                    <span>Inventory</span>
                  </Link>
                </div>
              </div>
            </div>

            <NavLink to="/myshop/charts/" className="navbar-item">
              <span className="zmdi zmdi-chart mr-2"></span>
              <span className="">Charts</span>
            </NavLink>

            <div className="navbar-item has-dropdown is-hoverable">
              <div className="navbar-link">
                <span className="zmdi zmdi-shopping-cart mr-2"></span>
                Sales
              </div>

              <div className="navbar-dropdown">
                <div className="navbar-item">
                  <Link to="/myshop/sales/sales-records/">Sales Records</Link>
                </div>
                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/sales/sold-items/">Sold Items</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/sales/online-orders/">Online Orders</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/sales/top-sales/">Top Sales</Link>
                </div>
              </div>
            </div>

            <NavLink to="/myshop/cash-outflow/" className="navbar-item">
              <span className="zmdi zmdi-arrow-back mr-1"></span>
              <span className="zmdi zmdi-money mr-2"></span>
              <span className="">Cash Out-flow</span>
            </NavLink>

            <div className="navbar-item has-dropdown is-hoverable">
              <div className="navbar-link">
                <span className="zmdi zmdi-book mr-2"></span>
                Debts
              </div>

              <div className="navbar-dropdown">
                <div className="navbar-item">
                  <Link to="/myshop/debts/credits/">Credits</Link>
                </div>
                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/myshop/debts/borrowed-items/">Borrowed Items</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <Link to="/shop/debts/paid-debts/">Paid Debts</Link>
                </div>
              </div>
            </div>

            <NavLink to="/myshop/accounts/" className="navbar-item">
              <span className="zmdi zmdi-accounts mr-2"></span>
              <span className="">Accounts</span>
            </NavLink>
          </div>

          <div className="navbar-end">
            <div className="navbar-item has-dropdown is-hoverable">
              <div className="navbar-link">
                <span className="mr-2">
                  <img className="profile-image" src={defaultuser} alt="" />
                </span>
                <span>{this.state.user.first_name}</span>
              </div>

              <div className="navbar-dropdown">
                <div className="navbar-item">
                  <span className="zmdi zmdi-account mr-2"></span>
                  <Link to="/accounts/profile/">Profile</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <span className="zmdi zmdi-notifications mr-2"></span>
                  <Link to="/accounts/notifications/">Notifications</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <span className="zmdi zmdi-globe mr-2"></span>
                  <Link to="/accounts/languages/">Language</Link>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item">
                  <a href="/accounts/download/">
                    <span className="zmdi zmdi-download mr-2"></span>
                    Download
                  </a>
                </div>

                <hr className="navbar-divider" />

                <div className="navbar-item static-link has-text-danger">
                  <Link to="/logout/">
                    <span className="zmdi zmdi-power-off mr-2"></span>
                    Logout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
